import ApiService from '../../services/api.service';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import PersonalinfoModel from '../personalinfo/personalinfo-model';

export default class CivilnumberModel {
    id: number;
    name: string;
    description: string;
    status: string;
    type: string;
    typeCaption: string;
    seq: number;
    image: any;
    imageId: number;
    imageUrl: string;    
    personalinfo: any;
    personalinfoCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.type = datarow.type || 'ktp';
        this.typeCaption = CivilnumberModel.optionType.filter((d: any) => d.name === this.type)?.[0]?.caption || 'KTP';
        this.seq = datarow.seq;
        let personalinfo = datarow.personalinfo?.data? new PersonalinfoModel(datarow.personalinfo?.data) : datarow.personalinfo;
        this.personalinfo = personalinfo?.id;
        this.personalinfoCaption = personalinfo?.name; 
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        
    } 

    public static endPoint: string = 'civil-numbers';
    public static endPointMedia: string = 'api::civil-number.civil-number';
    public static endPointFilterList = (personalinfoId?: number) => {
        return ('?populate=*&sort=name&filters[personalinfo]=' + personalinfoId)
    }
    public static url: string = '/civilnumber';
    public static caption: string = 'Civil Number';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',    
        type: 'ktp',
        typeCaption: 'KTP',
        seq: 0,
        personalinfo: null,
        personalinfoCaption: '',
        image: null,
        imageId: 0,
        imageUrl: '',
  
        }
    }
    
    public static columns = [
        { name: 'name', caption: 'Number' },
        { name: 'typeCaption', caption: 'Type' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Number', type: 'caption' },
        { name: 'typeCaption', caption: 'Type' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'ktp', caption: 'KTP' },
        { name: 'kta', caption: 'KTA' },
        { name: 'sim', caption: 'SIM' },
        { name: 'npwp', caption: 'NPWP' },
    ]
}